
<sm-misc-title-bar [headerCustomTemplate]="addButton" pageTitle={{parentData.title}} [showBackButton]="false">
  <ng-template #addButton>
    <div class="d-flex search-field">
      <mat-form-field appearance="outline" class="me-2" *ngIf="toShowInventoryItems || toShowInventoryTemplate">
        <mat-label>{{ 'services.label' | translate }}</mat-label>
        <input
        [formControl]="searchString"
         
          matInput
          placeholder="{{ 'services.placeholder' | translate }}"
          (keyup)="searchServiceData()"
        />
        <button
        
          mat-button
          *ngIf="!searchString.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
        >
          <mat-icon>search</mat-icon>
        </button>
        <button
        mat-button
        *ngIf="searchString.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="reset()"
      >
        <mat-icon >close</mat-icon>
      </button>
      </mat-form-field>

      <button
      mat-icon-button
      mat-dialog-close
      class="align-self-end"
      color="accent"
    >
      <mat-icon style=" color: #000; position: relative; top: -5px;">close</mat-icon>
    </button>
    </div>
  </ng-template>
</sm-misc-title-bar>
<!-- inventory increase/decrease modal -->
  <mat-dialog-content *ngIf="!toShowInventoryItems && !toShowInventoryTemplate && (operation_type == 1 || operation_type == 2)" style="min-width: 400px;" >
    <div class="text-fieldss">
      <h3 style="    font-weight: 700;
      margin-bottom: 5px;">{{selectedInventoryData[0].item_name}}</h3>
      <!-- <p>{{selectedInventoryData[0].quantity_info}}</p> -->
      <p>Current stock: <strong>{{selectedInventoryData[0].current_purchase_stock}} {{selectedInventoryData[0].purchase_unit}}</strong> </p>
      <p>Minimum stock: <strong> {{selectedInventoryData[0].min_stock}} {{selectedInventoryData[0].purchase_unit}}</strong></p>
      <p>Purchase unit: <strong>{{selectedInventoryData[0].purchase_unit}}</strong></p>
      <p *ngIf="selectedInventoryData[0].selling_unit != selectedInventoryData[0].purchase_unit">Selling unit: <strong>{{selectedInventoryData[0].selling_unit}}</strong></p>
    </div>

    <div class="text-fieldss d-flex align-items-baseline" >
      <mat-form-field appearance="outline">
        <mat-label>{{operation_type == 1 ? 'Quantity to increase' : 'Quantity to decrease'}}</mat-label>
        <input smNumericOnly
          [(ngModel)]="inventoryListData.qty"
          matInput

        />
       
      </mat-form-field>
      <span style="margin-left: 10px;" *ngIf="selectedInventoryData[0].selling_unit == selectedInventoryData[0].purchase_unit">{{selectedInventoryData[0].purchase_unit}}</span>
      <!-- <p style="position: relative; top: -10px;">Purchase unit: <strong>{{selectedInventoryData[0].purchase_unit}}</strong></p>
      <p style="position: relative; top: -10px;">Selling unit: <strong>{{selectedInventoryData[0].selling_unit}}</strong></p> -->
    </div>
     <div style="margin-bottom: 10px;" *ngIf="selectedInventoryData[0].selling_unit != selectedInventoryData[0].purchase_unit">
        <!-- <mat-label></mat-label> -->
        <!-- <br><br> -->


        <input type="radio" id="selling" name="unit" value="1" (click)="discType($event)">
        <label for="selling" class="radlabel">{{selectedInventoryData[0].selling_unit}}</label>
        <input type="radio" id="purchase" name="unit" value="2" (click)="discType($event)">
        <label for="purchase" class="radlabel">{{selectedInventoryData[0].purchase_unit}}</label>

    </div>

    <div class="text-fieldss">
      <mat-form-field appearance="outline">
        <mat-label>Notes</mat-label>
        <textarea
          [(ngModel)]="inventoryListData.notes"
          matInput
        ></textarea>
       
      </mat-form-field>
    </div>
    <div class="text-fieldss">
      <mat-form-field appearance="outline">
        <mat-label>Barcode</mat-label>
        <input
          [(ngModel)]="inventoryListData.barcode"
          matInput
        />
       
      </mat-form-field>
    </div>
    
   
  </mat-dialog-content>

  <!-- new inventory item add modal -->
  <mat-dialog-content *ngIf="(!toShowInventoryItems && !toShowInventoryTemplate && operation_type == 3) || showInventoryAdd" style="width: 700px;">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Item name</mat-label>
        <input
          
          [(ngModel)]="newInventoryData.item_name"
          matInput
          #input
        />
       
        <!--  -->
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Item description</mat-label>
        <textarea
          [(ngModel)]="newInventoryData.item_desc"
          matInput
        ></textarea>
       
      </mat-form-field>
    </div>
    <div style="margin-top: 10px;">
      <mat-form-field appearance="outline">
        <mat-label>Purchase unit</mat-label>
        <input
          [(ngModel)]="newInventoryData.purchase_unit"
          matInput
        />
        <mat-hint align="start">Example: carton or kg or bottle etc</mat-hint>
      </mat-form-field>
    </div>
    <div style="margin-top: 20px;margin-bottom: 20px;">
      <mat-checkbox value="shop" (change)="change($event)" [checked]="newInventoryData.for_sale == 1"></mat-checkbox>
      <mat-label >Item for sale</mat-label>

    </div>
    
    <div *ngIf="newInventoryData.for_sale == 1">
      <mat-form-field appearance="outline">
        <mat-label>Selling unit</mat-label>
        <input
          [(ngModel)]="newInventoryData.selling_unit"
          matInput
        />
        <mat-hint align="start">Example: sachet or gm or ml etc</mat-hint>
      </mat-form-field>
    </div>
    <div *ngIf="newInventoryData.for_sale == 1">
      <mat-form-field appearance="outline">
        <mat-label>Selling quantity</mat-label>
        <input
          [(ngModel)]="newInventoryData.qty_info" smDecimalOnly type="number"
          matInput
        />
        <!-- <mat-hint align="start">Example: 100 ml bottle or 500 gm pack etc</mat-hint> -->
      </mat-form-field>
    </div>

    <div style="margin-top: 20px;margin-bottom: 5px;" class="d-flex align-items-center" *ngIf="newInventoryData.for_sale == 1 && newInventoryData.selling_unit != newInventoryData.purchase_unit">
        <!-- <mat-form-field appearance="outline" style="width: 25%;"> -->
        <!-- <label>Purchase unit</label> -->
        <input smDecimalOnly type="number"
          style="border-radius: 3px;border: 1px solid #c9c9c9;width: 75px;margin-right:10px;text-align: center;height: 35px;"
          [(ngModel)]="newInventoryData.selling_purchase_multiplier"
          matInput
        />
      <!-- </mat-form-field> -->
      <span [ngClass]="{'make-txt-grey': !newInventoryData.selling_unit}">{{newInventoryData.selling_unit ? newInventoryData.selling_unit : 'Selling unit'}}</span>
      <span style="margin-left: 5px; margin-right: 5px;"> =</span> 1 <span style="margin-left: 5PX;" [ngClass]="{'make-txt-grey': !newInventoryData.purchase_unit}">{{newInventoryData.purchase_unit ? newInventoryData.purchase_unit : 'Purchase unit'}}</span><br>
    </div>
    <mat-hint align="start" style="font-size: 75%;" *ngIf="newInventoryData.for_sale == 1 && newInventoryData.selling_unit != newInventoryData.purchase_unit">Example: 100 sachet = 1 carton or 1000gm = 1kg</mat-hint>

<div class="row">
  <div class="col-sm-6">
    <div style="margin-top: 20px; " class="d-flex align-items-center">
      <div style="margin-right: 10px;">
        <mat-form-field appearance="outline">
          <mat-label>Minimum stock</mat-label>
          <input smNumericOnly
          [(ngModel)]="newInventoryData.min_stock"
          matInput/>
          
        </mat-form-field>
      </div>
      <span style="position: relative;top: -9px;  display: block;line-break: anywhere;">{{newInventoryData.purchase_unit}}</span>
    </div>
    </div>
     <div class="col-sm-6">
    <div style="margin-top: 20px; " class="d-flex align-items-center">
      <div style="margin-right: 10px;">
        <mat-form-field appearance="outline">
          <mat-label>Current stock</mat-label>
          <input smNumericOnly [disabled]="editMode"
            [(ngModel)]="newInventoryData.current_stock"
            matInput
  
          />
         
        </mat-form-field>
      </div>
      <span style="    position: relative; display: block;line-break: anywhere;
    top: -9px;">{{newInventoryData.purchase_unit}}</span>

    </div>
    </div>
</div>

    <div style="display: flex; justify-content: center; align-items: center">
      <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
    </div>
    <div class="image-preview" *ngIf="assetList.length > 0" style="position: relative;    width: fit-content;    margin-bottom: 20px;    border: 1px solid lightgray;
      padding: 15px;
  ">
      <img [src]="assetList[assetList.length - 1].url" alt="" style="width: 200px; height: 170px; object-fit: cover;">
      <span (click)="removeAsset()" style="position: absolute;
      cursor: pointer;
      top: 0;
      right: 0;
      background: #dd2c00;
      border-radius: 50%;
      height: 30px;
      width: 30px;" ><mat-icon style="    position: absolute;
    left: 3px;
    top: 2px;
    color: white;" class="material-icons-outlined">close</mat-icon></span>
    </div>
    
    <div class="upload-group mb-2">
      <label for="formFile" class="form-label">Upload media</label>
      <div class="file-input-wrap">
        <div class="custom-input-label">
          <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
            >backup</mat-icon
          >
          <p>Drop your file(s) here or <span>browse</span></p>
        </div>
        <input
          class="form-control"
          id="formFile"
          accept="image/*"
          type="file"
          multiple
          (change)="onUploadImage($event)"
        />
      </div>
      <!-- <mat-chip-list #chipList style="margin-top: 2px">
        <mat-chip style="width: 100%; padding: 10px">File</mat-chip>
      </mat-chip-list> -->
    </div>
  </mat-dialog-content>

  <!-- inventory items -->
  <mat-dialog-content *ngIf="toShowInventoryItems" style="min-width: 80vw;">
    <div class="row" *ngIf="inventoryItems.length>0">
        <div class="col-sm-4 service_temple_card" *ngFor="let item of inventoryItems">
            <div class="fl_orders" (click)="selectInventoryTemplate(item)">
                <div class="top_section_order">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="ads_sec">
                                <div class="hm_icon_progr" *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'">
                                    <img [src]="item.image_thumb_url">
                                </div>
                                <div class="hm_icon_progr" *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'">
                                    <img src="../../../../assets/images/photo.png">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-10">
                            <div class="order_dec">
                              
                                <div class="tick_opklads" [ngStyle]="{'background': item.selected ? '#1da942' : 'lightgrey'}" >
                                    <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
                                    <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon
            >
                                </div>
                                <h3 style="-webkit-box-orient: vertical;
                                display: -webkit-box;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: normal;
                                ">{{item.item_name}}</h3>
                                <!-- <p>{{
                                  item.item_desc.length > 15
                                    ? item.item_desc.substring(0, 15) + "..."
                                    : item.item_desc
                                }}
                                </p> -->
                                <!-- <p>Home: Rs.{{item.home_rate}}, Shop: Rs.{{item.shop_rate}}
                                </p> -->
                                <!-- <p>Quantity info: {{item.quantity_info}}
                                </p> -->
                                <!-- <p class="pricecls">Price: <b>Rs.</b> </p> -->
                                <!-- <input type="text" [(ngModel)]="item.price" [disabled]="item.isDisabled == true"> -->
                                 <p
                                  class="two-line-ellipsis"
                                  [matTooltip]="item.item_desc"
                                  matTooltipPosition="above"
                                >
                                  {{ item.item_desc }}
                                </p>

                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

        <div *ngIf="datalength > inventoryItems.length" style="text-align: center;">
          <button
          style="
          width: 25%;
          border-radius: 50px;
      "
      mat-flat-button
      color="accent"
      (click)="seeMore()"
    >
      See more
    </button>
   
        </div>
        

    </div>
    <div class="row" *ngIf="inventoryItems.length == 0 && loading">
      <div style="padding: 50px 0px; text-align: center;">
        <h2>Loading Inventory Items</h2>
      </div>
    </div>
    <div class="row" *ngIf="inventoryItems.length == 0 && !loading" >
      <div style="padding: 50px 0px; text-align: center;">
        <h2>No inventory items to show</h2>
      </div>
    </div>
  </mat-dialog-content>
  <!-- inventory items template -->
  <mat-dialog-content *ngIf="toShowInventoryTemplate" style="min-width: 80vw;">
    <div class="row" *ngIf="inventoryTemplateData.length>0">
        <div class="col-sm-4 service_temple_card" *ngFor="let item of inventoryTemplateData">
            <div class="fl_orders" (click)="selectInventoryTemplateDataByKeyword(item)">
                <div class="top_section_order">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="ads_sec">
                                <div class="hm_icon_progr" *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'">
                                    <img [src]="item.image_thumb_url">
                                </div>
                                <div class="hm_icon_progr" *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'">
                                    <img src="../../../../assets/images/photo.png">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-10">
                            <div class="order_dec">
                              
                                <div class="tick_opklads" [ngStyle]="{'background': item.selected ? '#1da942' : 'lightgrey'}" >
                                    <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
                                    <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon
            >
                                </div>
                                <h3 style="-webkit-box-orient: vertical;
                                display: -webkit-box;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: normal;
                                ">{{item.item_name}}</h3>
                                <!-- <p>{{
                                  item.item_desc.length > 15
                                    ? item.item_desc.substring(0, 15) + "..."
                                    : item.item_desc
                                }}
                                </p> -->
                                  <p
                                  class="two-line-ellipsis"
                                  [matTooltip]="item.item_desc"
                                  matTooltipPosition="above"
                                >
                                  {{ item.item_desc }}
                                </p>
                                <!-- <p>Home: Rs.{{item.home_rate}}, Shop: Rs.{{item.shop_rate}}
                                </p> -->
                                <p>Quantity info: {{item.quantity_info}}
                                </p>
                                <!-- <p class="pricecls">Price: <b>Rs.</b> </p> -->
                                <!-- <input type="text" [(ngModel)]="item.price" [disabled]="item.isDisabled == true"> -->
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

        <div *ngIf="datalength > inventoryTemplateData.length" style="text-align: center;">
          <button
          style="
          width: 25%;
          border-radius: 50px;
      "
      mat-flat-button
      color="accent"
      (click)="seeMore()"
    >
      See more
    </button>
   
        </div>
        

    </div>
    <div class="row" *ngIf="loading">
      <div style="padding: 50px 0px; text-align: center;">
        <h2>Loading Inventory Templates</h2>
      </div>
    </div>
    <div class="row" *ngIf="inventoryTemplateData.length == 0 && !loading">
      <div style="padding: 50px 0px; text-align: center;">
        <h2>No inventory templates to show</h2>
      </div>
    </div>
  </mat-dialog-content>
  
  <!-- buttons when showing adding new inventory modal -->
  <mat-dialog-actions align="end" *ngIf="(!toShowInventoryItems && !toShowInventoryTemplate && operation_type == 3) || showInventoryAdd">
    <button mat-button mat-dialog-close *ngIf="!showInventoryAdd">Cancel</button>
    <button mat-button (click)="backFromInventoryTemplate()" *ngIf="showInventoryAdd">Back</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !newInventoryData.item_name 
      "
      (click)="onAddEditInventoryItem()"
    >
      {{ editMode ? "Confirm" : "Confirm" }}
    </button>
  </mat-dialog-actions>
  <!-- buttons when showing increase/decrease modal -->
  <mat-dialog-actions align="end" *ngIf="!toShowInventoryItems && !toShowInventoryTemplate && (operation_type == 1 || operation_type == 2)">
    <button mat-button (click)="back()">Back</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !inventoryListData.qty || inventoryListData.qty == '' || !typeofactivity
      "
      (click)="onPost()"
    >
      {{ editMode ? "Confirm" : "Confirm" }}
    </button>
  </mat-dialog-actions>

<!-- buttons when showing inventory items -->
  <mat-dialog-actions align="end" *ngIf="toShowInventoryItems">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      [disabled]="
      selectedInventoryData.length == 0

      "
      mat-flat-button
      color="accent"
      (click)="onSelectNext()"
    >
      Next
    </button>
  </mat-dialog-actions>
<!-- buttons when showing inventory template items -->
  <mat-dialog-actions align="end" *ngIf="toShowInventoryTemplate">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      [disabled]="
      selectedInventoryTemplateData.length == 0

      "
      mat-flat-button
      color="accent"
      (click)="onSelectNextOnTemplateData()"
    >
      Next
    </button>
  </mat-dialog-actions>
  